import * as React from "react";
import { Router } from "react-router";
import { Route } from "react-router-dom";
import { get as getCookie } from "es-cookie";
import { bindActionCreators } from "redux";
import { authenticationAction } from "../_actions";
import { connect } from "react-redux";

import { history } from "../_store";
import { LoginForm } from "../_components/Login";
import { AuthRoute } from "../_components/AuthRoute";
import { SidePanel } from "../_components/SidePanel";
import { OrderList, OrderDetail } from "../_components/Order";
import { LicenceList, LicenceDetail, NewLicence } from "../_components/Licence";
import { SystemList } from "../_components/System";
import { Settings } from "../_components/Settings";
import { Notification } from "../_components/Notification";
import "../_scss/styles.scss";
import { PaymentSuccess } from "../_components/PaymentSuccess";

const App = () => {
  return (
    <React.Fragment>
      <Router history={history}>
        <div className="page-content">
          <SidePanel />
          <main className="right-panel">
            <Notification />
            <Route path="/login" exact component={LoginForm} />
            <Route path="/payment-success" exact component={PaymentSuccess} />
            <AuthRoute path="/" exact component={OrderList} />
            <AuthRoute path="/system-list" exact component={SystemList} />
            <AuthRoute path="/order-list" exact component={OrderList} />
            <AuthRoute path="/order-detail" exact component={OrderDetail} />
            <AuthRoute path="/order-detail/:id" component={OrderDetail} />
            <AuthRoute path="/licence-list" exact component={LicenceList} />
            <AuthRoute path="/licence-detail/:id" component={LicenceDetail} />
            <AuthRoute path="/settings" exact component={Settings} />
            <AuthRoute path="/new-licence" exact component={NewLicence} />
          </main>
        </div>
      </Router>
    </React.Fragment>
  );
};

class AppClass extends React.Component<any, any> {
  constructor(props:any) {
    super(props);
  }
  componentDidMount() {
    console.log(this.props);
    // if (getCookie("token") != ""
    //   && !this.props.authentification.authenticated) {
    //   this.props.refreshUser();
    // }
  }

  render() {
    return (
      <>
        <App />
      </>
    );
  }
}

function mapDispatchToProps(dispatch: any) {
  return bindActionCreators({
    refreshUser: authenticationAction.refresh,
  },
    dispatch
  );
}

function mapStateToProps(state: any) {
  return {
    authentification: state.authentication
  };
}

const AppComponent = connect(mapStateToProps, mapDispatchToProps)(AppClass);

export { AppComponent as App };